import i18n from "i18next";

import type { Movement } from "api/services/content/schemas/shared";

export function translateMovement(movement: Movement): string {
  const keyMap: Record<Movement, string> = {
    abduction: i18n.t("library.exercises.fields.movement_options.abduction"),
    adduction: i18n.t("library.exercises.fields.movement_options.adduction"),
    extension: i18n.t("library.exercises.fields.movement_options.extension"),
    external_rotation: i18n.t("library.exercises.fields.movement_options.external_rotation"),
    flexion: i18n.t("library.exercises.fields.movement_options.flexion"),
    internal_rotation: i18n.t("library.exercises.fields.movement_options.internal_rotation"),
    lateral_flexion: i18n.t("library.exercises.fields.movement_options.lateral_flexion"),
  };

  return keyMap[movement] || "";
}
